<template>
  <ul class="list-ul">
    <li class="list-item" v-for="(item, index) in list" :key="index" @click="toDetail(item)">
        <img v-if="mote(item).url" class="item-img" :src="mote(item).url"/>
        <aside>
          <h5 class="item-title">{{ mote(item).name }}</h5>
          <p v-if="source === 'MOTE'"> {{ mote(item).fans }}粉丝 <br />{{ mote(item).state }}<br />{{ mote(item).signature }}</p>
          <template v-if="source === 'MOTEDETAIL'">
            <p class="item-time"> {{ mote(item).time }}</p>
            <p class="item-content" style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;padding-top: 5px;line-height: 20px;font-size: 12px;"> {{ mote(item).content }}</p>
          </template>
        </aside>
    </li>
  </ul>
</template>
<script>
  export default {
    props: {
      list: Array,
      source: String
    },
    methods: {
      mote (item) {
        let url, name, fans, state, signature, time, content;
        if (this.source === 'MOTE') {
            url = item.basic.headPortraitHttps;
            name = item.basic.nickName;
            fans = item.followerNumDesc;
            state = item.relationship;
            signature = item.signature;
        } else if (this.source === 'MOTEDETAIL') {
          const pictures = item.article.content.filter(item => {
            return item.contentType === 'PICTURE'
          });
          const articles = item.article.content.filter(item => {
            return item.contentType === 'TEXT'
          });
          url = pictures[0] ? pictures[0].content : null;
          content = articles[0] ? articles[0].content : '';
          name = item.article.title;
          time = item.article.createdAtForRead;
        }
        return {
          url,
          name,
          fans,
          state,
          signature,
          time,
          content
        }
      },
      toDetail (item) {
        let url = null;
        if ('MOTE' === this.source) {
          url = item.basic.pinyinName ? `/mote/${ item.basic.pinyinName }/` : `/mote/`
        } else if ('MOTEDETAIL' === this.source) {
          url = `/mote/news/${ item.article.numberId }.html`
        }
        window.location.href = url;
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .list-ul {
    background-color: #FFF;
    margin-top: 10px;
  }
  .list-item {
    height: 122px;
    overflow-y: hidden;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 10px;
    padding: 0 10px 5px;
    box-shadow: 1px 1px 2px #f4f4f4;
    font-size: 14px;
    .item-img {
      width: px2rem(120px);
      border-radius: 1px;
      margin-right: 10px;
    }
    .item-title {
      width: px2rem(205px);
      font-size: 14px;
      line-height: 22px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .item-time {
      font-size: 12px;
      color: #aaa;
      line-height: 20px;
    }
    /*.item-content {
    }*/
  }
  .list-item:nth-child(1) {
    padding-top: 10px;
  }
  .list-item:last-child {
    margin-bottom: 0;
  }
  #pagination {
    padding-top: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/List.vue